module.exports = __webpack_public_path__ + "static/james-altucher-0df5dfa489c628d3cfd379a3b719cb59.jpg";